import React, { useEffect, useState } from 'react';
import { Table, Text, Flex, Select, Space, Title, Group, UnstyledButton, Divider } from '@mantine/core';
import { addClientToOrganization, addClientToOrganizationViaEmail, deleteClientFromOrganisation, getOrganizationClients, useAppDispatch, useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { Image, Users, Lock } from '@geist-ui/icons';
import { AutomatedAuditLoader, Button, TextInput , Modal } from '@common/components';
import { useTranslation } from 'react-i18next';
import { useAlert, useFormFocus } from '@common/hooks';
import styles from "./styles.module.scss"
import { useForm } from '@mantine/form';
import { validateUserIdentifier } from 'src/helpers/organization';
import { useDisclosure } from '@mantine/hooks';
import classNames from 'classnames';


type addUserOption = 'uuid' | 'Email' | '';

const AllClients: React.FC = () => {
  const [t] = useTranslation('account');
  const {
    
    loading,
    organizationClients,
    loadingorganizationClients,
    organizationClientsError,
    organizationInvitationViaEmail,
    loadingOrganizationInvitationViaEmail,
    organizationInvitationViaEmailError,
    currentUserOrgAuth
  } = useAppSelector((state) => state.organization, shallowEqual);
  
  const user = useAppSelector((state) => state.user.data, shallowEqual);
  const organiszation_Id = user.organizationsId ;

  const dispatch = useAppDispatch();
  const { showAlert } = useAlert();
  const [opened, { open, close }] = useDisclosure(false);

  const clients = [
    { id: 1, name: 'Client One', email: 'client1@example.com' },
    { id: 2, name: 'Client Two', email: 'client2@example.com' },
    { id: 3, name: 'Client Three', email: 'client3@example.com' },
    // Add more clients as needed
  ];
  const [clientList, setClientList] = useState(clients);
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [typeOfAddingnewuser, setTypeOfAddingnewuser] = useState<addUserOption>('Email')

  const openDeleteModal = (client: any) => {
    // if(!hasPermission){
    //   return;
    // }
    setSelectedClient(client);
    setModalOpened(true);
  };

  const closeDeleteModal = () => {
    setSelectedClient(null);
    setModalOpened(false);
  };

  const deleteClient = () => { 
    // if(!hasPermission){
    //   return;
    // }
    
    if (selectedClient) {
      const updatedClients = organizationClients?.filter((client:any) => client.tenantId !== selectedClient?.tenantId);
      setClientList(updatedClients);

      // TODO : this api should be checked 'delete'
      dispatch(deleteClientFromOrganisation({
        organisationId: organiszation_Id,
        clientTenantId : selectedClient?.tenantId // tenantId
      }))
      dispatch(getOrganizationClients({ organisationId : organiszation_Id }));
      closeDeleteModal();
    }
  };  

  const form = useForm({
    initialValues: {
        userIndifier: '',
    },
    validate: {
        userIndifier: (value) =>{
          const notValid = validateUserIdentifier(value, typeOfAddingnewuser)
          if ( notValid ) {
            setNeedFocus(true)
          }
          return notValid
        }
    },
});
const { setNeedFocus } = useFormFocus({ formErrors: form.errors });

  // Function to send invite to an account to join an organization
  const sendInvite = (inditfier: string, type: string) => {

    // Add logic to send invite 
    if (type === 'uuid') {
        dispatch(addClientToOrganization({
            organisationId: organiszation_Id,
            clientTenantId: inditfier
        }));
    } else if (type === "Email") {
        // add user using email address.
        dispatch(addClientToOrganizationViaEmail({
            organisation_id: organiszation_Id,
            client_email: inditfier
        }))
        if ( organizationInvitationViaEmailError !== "error" ) {

            showAlert({
              id:  inditfier,
              title: 'Adding users to organization Via Email',
              message: `The client with the specified email address ${inditfier} was successfully added`,
              variant: 'success',
            });

        }else {
            showAlert({
              id:  inditfier,
              title: 'Unable to add users to organization',
              message: `The client with the specified email address ${inditfier} was not added`,
              variant: 'error',
            });
        }
    }
};


  // get the list of the client withing the organization.
  useEffect(() => {    
    // if (organizationClients) {
    //   return
    // }
    dispatch(getOrganizationClients({ organisationId : organiszation_Id }));
  }, [])

  return (
    <div className={styles.wrapper} style={{ width: '100%', flex: '1', padding:' 3rem'    }}>
         <Title className={styles['second-heading']} color={'#264547'} mb={'18px'} order={1}>
              {/* {  t('notificationTab.manageUsersTitle') } */}
              Manage Clients
          </Title>
        {/* <Select
            // label="Add User By"
            label={'Choose how you would like to add a new Client.'}
            placeholder="Pick value"
            data={['Email', 'uuid']}
            defaultValue="Email"
            allowDeselect
            mt="md"
            onChange={(type: addUserOption) => {
                if (type) {
                    setTypeOfAddingnewuser(type)
                }
            }}
        /> */}
           <Space h={"sm"} />
      {

          <>
              <form className={styles.form} onSubmit={form.onSubmit((values) => {
                  sendInvite(values?.userIndifier, "Email")
              })} >
                  {/* <h3>{t('userTab.inviteUsers')}</h3> */}
                  <Flex w={'100%'} justify={'center'} gap={'md'}>
                      <TextInput
                          autoFocus
                          className={styles.input}
                          placeholder={'Enter Client Email example : client@vially.io'}
                          {...form.getInputProps('userIndifier')}
                      />
                      
                      <Button type='submit'
                              // disabled={!hasPermission}
                      >
                        <Flex gap={'5px'}>
                                  {/* { !hasPermission  && <Lock size={16} aria-label={`${t('lockedItem')}`} />} */}
                                {t('userTab.sendInvite')}
                        </Flex>
                          
                      </Button>
                  </Flex>
              </form>
              <Space h={"sm"} />
              {/* <h3>{t('userTab.organizationAccountsTitle')} </h3> */}
            
              {
                  ( loadingOrganizationInvitationViaEmail || loading ) &&   <>
                      <span>Adding New Client </span>
                  </>
              }
          </>
          // :
          // null

      }
      <table className={styles.table}>
        <thead>
          <tr>
            <th>{t('userTab.tabel.name')} </th>
            <th>{t('userTab.tabel.email')} </th>
            {
              <th>{t('userTab.tabel.actions')} </th>
            }
          </tr>
        </thead>
        <tbody>
        {  organizationClients  ? (
          organizationClients.map((client: any, index: number) => ( 
                <tr key={client.userId}>
                  <td>
                    <Flex align={'center'} gap={'sm'}>
                      {client.firstName +' '+client.lastName}
                    </Flex>
                  </td>
                  <td>{client.email}</td>
                  {/* <td>Admin</td> */}
                  {
                    <td>
                      <Button color='dark-green' onClick={() => {
                        open()
                        openDeleteModal(client)
                      }}    
                              aria-label="Delete client"   
                              // disabled={!hasPermission}
                        >
                          <Flex gap={'5px'}>
                                    {/* { !hasPermission  && <Lock size={16} aria-label={`${t('lockedItem')}`} />} */}

                                  Delete
                          </Flex>

                      </Button>
                    </td>
                  }
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4}>
                    <Flex mt={"lg"} direction={"column"} gap={"sm"} justify={"center"} align={"center"}>
                      <Users />
                      <p>Organisation <strong>{user?.name }</strong> has No Client yet. </p>
                    </Flex>
                  </td>
              </tr>
            )
          }
          {loadingorganizationClients && ( <span>
            Loading ...
            <AutomatedAuditLoader />
            </span>
            )
            }

        </tbody>
      </table>
      <Modal opened={opened} close={close} zIndex={1000} withCloseButton={false} size={416} padding={0}>
        <Group align={'center'} position={'center'} p={28}>
          <Title order={2}>Delete Client</Title>
          <Text align={'center'}>
            Are you sure you want to delete <strong> {selectedClient?.firstName} {selectedClient?.lastName}</strong>  from the organisation?</Text>
        </Group>
        <div className={classNames(styles['btn-group'])}>
          <UnstyledButton onClick={close} className={classNames(styles['action-btn'])}>
            {t('modalCancel')}
          </UnstyledButton>
          <Divider orientation={'vertical'} color={'gray'} my={'none'}></Divider>
          <UnstyledButton  aria-label='Delete client' onClick={deleteClient} className={classNames(styles['action-btn'] , styles.btndelete)}>
            {t('modalDelete')}
          </UnstyledButton>
        </div>
      </Modal>

    </div>
  );
};

export default AllClients;
